import { useQueryClient } from '@tanstack/react-query';

import { useAppDispatch } from '@store/store';

import { setIsMapDataUpdateNeeded } from '@slices/map';

import {
	ASSETS,
	ASSETS_LIST,
	ASSETS_LIST_SHOW_HIDE_ALL,
	ASSETS_LIST_SHOW_HIDE_FILTER,
	FILTER_THRESHOLDS,
} from '@constants/queryKeys';

export const useInvalidateAssetsList = () => {
	const queryClient = useQueryClient();
	const dispatch = useAppDispatch();
	const invalidateAssetsList = () => {
		dispatch(setIsMapDataUpdateNeeded(true));

		return [
			queryClient.invalidateQueries([ASSETS]),
			queryClient.invalidateQueries([ASSETS_LIST]),
			queryClient.invalidateQueries([FILTER_THRESHOLDS]),
		];
	};

	const invalidateVisibleShowHideAssets = () => {
		return [
			queryClient.invalidateQueries([ASSETS_LIST_SHOW_HIDE_FILTER]),
			queryClient.invalidateQueries([ASSETS_LIST_SHOW_HIDE_ALL]),
		];
	};

	return {
		invalidateAssetsList,
		invalidateVisibleShowHideAssets,
	};
};
